const SAFE_URL_PATTERN = /^https?:\/\//i;
const SAFE_PATH_PATTERN = /^\/[a-zA-Z0-9\-._~:/?#[\]@!$&'()*+,;=%]*$/;

export const sanitizeUrl = (url: string): string => {
  if (!url || typeof url !== "string") {
    return "";
  }

  const trimmedUrl = url.trim();

  if (!SAFE_URL_PATTERN.test(trimmedUrl)) {
    return "";
  }

  try {
    const parsed = new URL(trimmedUrl);
    if (parsed.protocol !== "http:" && parsed.protocol !== "https:") {
      return "";
    }
    return parsed.href;
  } catch {
    return "";
  }
};

export const sanitizePathname = (pathname: string): string => {
  if (!pathname || typeof pathname !== "string") {
    return "/";
  }

  const trimmed = pathname.trim();

  if (!trimmed.startsWith("/")) {
    return "/";
  }

  if (!SAFE_PATH_PATTERN.test(trimmed)) {
    return "/";
  }

  const decoded = decodeURIComponent(trimmed);
  if (decoded.includes("javascript:") || decoded.includes("data:")) {
    return "/";
  }

  return trimmed;
};

export const buildCanonicalUrl = (
  baseUrl: string,
  pathname: string
): string => {
  const safePath = sanitizePathname(pathname);
  return `${baseUrl}${safePath}`;
};
